module.exports = __webpack_public_path__ + "img/zurou.9114bee1.png";